import { SURF_FORECAST_NAV } from './site-navigation.mjs'
import image from '../assets/images/surfers_walking_beach.jpg'
import imagePool from '../assets/images/overPool.jpg'
import roomSuites from '../assets/images/driftwood.jpg'
import food from '../assets/images/food1.jpg'
import rinjani from '../assets/images/mountRingani.jpeg'
import bookNow from '../assets/images/fastFerry.jpg'
import contact from '../assets/images/travelTips.webp'

export const navigation = {
  stay: {
    id: '00',
    header: 'Where to Stay',
    text: 'Discover locally-owned accommodations in Selong Belanak and surrounding villages.',
    image: roomSuites,
    path: '/where-to-stay',
    label: [{ header: 'Accommodation Guide', path: '/where-to-stay' }],
  },
  eat: {
    id: '01',
    header: 'Eat & Drink',
    text: 'Explore the best restaurants, cafés, and local warungs around Selong Belanak.',
    image: food,
    path: '/eat-drink',
    label: [{ header: 'Where to Eat', path: '/eat-drink' }],
  },
  surf: {
    id: '02',
    header: 'Beaches & Surfing',
    text: 'Find out where to surf and relax around Selong Belanak and South Lombok.',
    image: image,
    path: '/beaches-surfing',
    label: [
      { header: 'Beaches & Surfing', path: '/beaches-surfing' },
      { header: 'Surf Schools', path: '/surf' },
    ],
  },
  things: {
    id: '03',
    header: 'Things to Do',
    text: 'Make the most of your visit with unique activities and local experiences.',
    image: rinjani,
    path: '/things-to-do',
    label: [
      { header: 'Things to Do', path: '/things-to-do' },
      { header: 'Festivals & Events', path: '/events-festivals' },
    ],
  },
  getting: {
    id: '04',
    header: 'Getting Here',
    text: 'Everything you need to know to reach Selong Belanak and travel around Lombok.',
    image: bookNow,
    path: '/getting-to-selong-belanak',
    label: [
      {
        header: 'Getting to Selong Belanak',
        path: '/getting-to-selong-belanak',
      },
      { header: 'Getting Around', path: '/getting-around' },
      { header: 'Travel Tips', path: '/travel-tips' },
    ],
  },
  community: {
    id: '05',
    header: 'Community & SBCA',
    text: 'Support local waste management, education and community action in Selong Belanak.',
    image: image,
    path: '/sbca',
    label: [
      { header: 'About the SBCA', path: '/sbca' },
      { header: 'Community Events', path: '/events-festivals' },
    ],
  },
  about: {
    id: '06',
    header: 'About',
    text: 'Learn more about Selong Belanak and the local community.',
    image: image,
    path: '/about',
    label: [
      { header: 'About Selong Belanak', path: '/about' },
      { header: 'Editorial Policy', path: '/editorial-policy' },
    ],
  },
  contact: {
    id: '07',
    header: 'Contact',
    text: 'Get in touch with the team behind the Selong Belanak Info Site.',
    image: contact,
    path: '/contact',
    label: [{ header: 'Contact Us', path: '/contact' }],
  },
}

export const structuredNavArray = [
  { id: 'planning', header: 'Plan your visit', path: '/#plan-your-visit', label: [
    { header: 'Getting here', path: '/getting-to-selong-belanak' },
    { header: 'Getting around', path: '/getting-around' },
    { header: 'Best time to visit', path: '/blog/best-time-to-visit-selong-belanak' },
    { header: 'Travel tips', path: '/travel-tips' },
    { header: 'Three-day itinerary', path: '/blog/three-day-selong-belanak-itinerary' },
    { header: 'All guides', path: '/blog' },
    { header: 'Places directory', path: '/explore' },
  ] },
  navigation.stay,
  navigation.eat,
  navigation.surf,
  SURF_FORECAST_NAV,
  navigation.things,
  navigation.community,
  navigation.about,
  navigation.contact,
]

export const itemIds = structuredNavArray
